import styled from 'styled-components'
import { BqToast } from '@beeq/react'

export const StyledBqToast = styled(BqToast)`
  --bq-toast--icon-color-info: var(--bq-iris-600);

  ::part(wrapper){
    box-shadow: var(--bq-box-shadow--l);
    font-weight: var(--bq-font-weight--medium);
  }

  ${props => props.open
    ? `&[hidden] {
      display: inline-block !important;
      visibility: visible !important;
    }`
    : null
  }
`
